import styled from 'styled-components';
import { themes } from "../../theme/theme";

const BorderContainer = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 60;
  background: rgba(0, 0, 0, 0.85);
  iframe {
    border: none;
  }
`;
const CustomIframe = styled.iframe`
  width: 100%;
  height: 100%;
`;
const Container = styled.div`
  width: 75%;
  height: 80%;
  min-height: 70rem;
  background-color: ${themes.colors.colorWhite};

  margin: auto;
  display: flex;
  margin-top: 5%;
  @media (max-height: 550px) {
    height: 95%;
    min-height: 0;

    margin-top: 1%;
    margin-bottom: 1%;
  }
  @media ${themes.device.laptopL} {
    width: 80%;
    min-height: 55rem;
  }
  @media ${themes.device.laptop} {
    width: 85%;
    min-height: 50rem;
  }
  @media ${themes.device.tabletS} {
    margin-top: 7rem;
  }
  @media (max-height: 520px) {
    min-height: 97%;
  }
`;

const LinkImage = styled.a`
  width: 90%;
  height: 9rem;
  display: flex;
  align-items: center;
`;
const Close = styled.span`
  font-size: 5rem;
  height: 9rem;
  position: fixed;
  align-items: center;
  cursor: pointer;
  top: 3rem;
  right: 3rem;
  color: ${themes.colors.colorWhite};
  :hover {
    color: ${themes.colors.colorGray6};
  }
  @media ${themes.device.laptop} {
    top: 0.2rem;
    right: 1.5rem;
  }
  @media ${themes.device.tablet} {
    font-size: 4rem;
  }
`;
export { Container, LinkImage, Close, BorderContainer, CustomIframe };
